import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Table, TableHeader, TableCell, TableBody, DataTableCell } from '@david.kucsai/react-pdf-table';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 10
  },
  section: {
    marginLeft: 10,
    marginRight: 10,
    marginTop: 7,
    marginBottom: 3
  },
  row: {
    display: "flex",
    flexDirection: "row"
  },
  column: {
    width: "50%",
    fontSize: 11,
    paddingBottom: 5
  },
  table: {
    marginTop: "-40px"
  },
  tableCell: {
    fontSize: 10,
    padding: 3,
    wordBreak: "break-all",
    whiteSpace: "pre-wrap"
  },
  snCell: {
    maxWidth: "30px",
    minWidth: "30px",
    width: "30px"
  },
  roomCell: {
    maxWidth: "100px",
    minWidth: "100px",
    width: "100px"
  },
  watermark: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: [{ rotate: '45deg'}]
  },
  watermarkText: {
    color: "#ddd",
    opacity: 0.8,
    fontSize: 180
  }
});

class MasterSheet extends Component {
  render() {
    const { rooms, fromData } = this.props
    
    return (
      <Document
        author="Manish Baral"
        creator="Manish Baral"
      >
        <Page style={styles.page}>
          <View style={styles.watermark}>
            <Text style={styles.watermarkText}>DRAFT</Text>
          </View>
          <View style={styles.section}>
            <View style={styles.row}>
              <View style={styles.column}>
                <Text>Date: { fromData.date }</Text>
              </View>
              <View style={styles.column}>
                <Text>Exam Center: { fromData.examCenter }</Text>
              </View>
            </View>

            <View style={styles.row}>
              <View style={styles.column}>
                <Text>Level: { fromData.level }</Text>
              </View>
              <View style={styles.column}>
                <Text>Duration: { fromData.duration }</Text>
              </View>
            </View>

            <View style={styles.row}>
              <View style={styles.column}>
                <Text>Programme: { fromData.program }</Text>
              </View>
              <View style={styles.column}>
                <Text>Year/Semester: { fromData.semester }</Text>
              </View>
            </View>

            <View style={styles.row}>
              <View style={styles.column}>
                <Text>Subject:  { fromData.subject }</Text>
              </View>
              <View style={styles.column}>
                <Text>Time: { fromData.time }</Text>
              </View>
            </View>
          </View>
          
          <View style={styles.section}>
            <Table style={styles.table} data={rooms}>
              <TableHeader>
                <TableCell style={[styles.tableCell, styles.snCell]}>S.N</TableCell>
                <TableCell style={[styles.tableCell, styles.roomCell]}>Room Num</TableCell>
                <TableCell style={[styles.tableCell, styles.rollCell]}>Roll Numbers</TableCell>
              </TableHeader>
              <TableBody>
                <DataTableCell style={[styles.tableCell, styles.snCell]} getContent={(r) => r.id}/>
                <DataTableCell style={[styles.tableCell, styles.roomCell]} getContent={(r) => r.roomNumber}/>
                <DataTableCell style={[styles.tableCell, styles.rollCell]} getContent={(r) => r.rollNumbers}/>
              </TableBody>
            </Table>
          </View>
        </Page>
      </Document>
    )
  }
}

MasterSheet.propTypes = {
  rooms: PropTypes.array,
  fromData: PropTypes.object
}

export default MasterSheet